// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-face-index-main_right_content-1xVNU","table":"components-face-index-table-1znrh"};


//////////////////
// WEBPACK FOOTER
// ./components/face/index.css
// module id = 2280
// module chunks = 0